import Vue from "vue";
import {
	SET_UPDATE_MODEL,
	SET_UPDATE_MODEL_ARRAY,
	ADD_TRANSPORT_SERVICE,
	SET_NEW_MODEL,
	SET_RESET_MODEL,
	SET_LOADING_RESERVATION,
	SET_LOADING_NOTA,
	DEL_TRANSPORT_SERVICE,
	ADD_TRANSPORT_SERVICE_CLONE,
	SET_NOTA,
	SET_UPDATE_TRANSPORT_SERVICE,
	SET_UPDATE_QUOTE_PROPS,
	initialState
} from "./contants";
export default {
	[SET_UPDATE_MODEL]: (state, payload) => {
		state.viewModel = {
			...state.viewModel,
			[payload.field]: payload.data
		};
	},
	[SET_UPDATE_MODEL_ARRAY]: (state, payload) => {
		const data = {
			...state.viewModel.transportServices[payload.index],
			[payload.field]: payload.data
		};
		Vue.set(state.viewModel.transportServices, payload.index, data);
	},
	[ADD_TRANSPORT_SERVICE]: state => {
		state.viewModel.transportServices.push(
			initialState().transportServices[0]
		);
	},
	[SET_UPDATE_TRANSPORT_SERVICE]: (state,payload) => {
		let indexTs = payload.index
		let dataTs  = payload.data
		let aux ={...state.viewModel.transportServices[indexTs]}
		Object.assign(aux,dataTs)
		Vue.set(state.viewModel.transportServices, indexTs, aux);
	},
	[SET_NEW_MODEL]: (state, payload) => {
		state.viewModel = payload;
	},
	[DEL_TRANSPORT_SERVICE]: (state, payload)=>{
		state.viewModel.transportServices.splice(payload,1)
	},
	[ADD_TRANSPORT_SERVICE_CLONE]: (state, payload) => {
		let aux ={...state.viewModel.transportServices[payload]};
		aux.id = -1;
		aux.status = "active";
		aux.serviceNumber = "",
		aux.supplierConfirmation = "pending";
		state.viewModel.transportServices.push(aux);
	},
	[SET_RESET_MODEL]: state => {
		state.viewModel = JSON.parse(JSON.stringify(initialState()));
	},
	[SET_NOTA]: (state, payload) => (state.notes = payload),
	[SET_LOADING_NOTA]: (state, payload) => (state.loadingNote = payload),
	[SET_LOADING_RESERVATION]: (state, payload) =>
		(state.loadingReservation = payload),
	[SET_UPDATE_QUOTE_PROPS]: (state,payload)=>{
		Object.assign(state.quote,payload)
	}
};
